import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import NoviZahtjeviZaUslugamaCard from "../components/NoviZahtjeviZaUslugamaCard";
import SaradnjaPonude from "../components/SaradnjaPonudeFizickoLice";
import "./LoginPravnogLicaUspio.scss";
import Head from "../modules/Head";
import HeaderComponent from "../components/HeaderComponent";
import "../components/InputPoruka.scss";
import axios from "axios";
import Cookies from "universal-cookie";
import config from "../config.json";

function LoginPravnogLica() {
  const { baseUrl, token } = config;
  const cookies = new Cookies();
  const user = cookies.get("pravnoLice");

  const [ponude, setPonude] = useState([]);
  const [historija, setHistorija] = useState([]);
  const [najprofKlijenti, setNajprofKlijenti] = useState([]);

  const [error, setError] = useState("");
  const [cookieData, setCookieData] = useState({});

  useEffect(() => {
    const getCookieData = (ime) => {
      const cookies = document.cookie.split(";");
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split("=");
        if (name === ime) {
          const decodedCookieValue = decodeURIComponent(value);
          return JSON.parse(decodedCookieValue);
        }
      }
      return {};
    };

    const data = getCookieData("pravnoLice");
    setCookieData(data);
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(
          `${baseUrl}/pravno/pristigli-zahtjevi/${user.korisnickoIme}`,
          {
            headers: {
              token: token,
              "Content-Type": "application/json",
            },
          }
        );
        const response2 = await axios.get(
          `${baseUrl}/pravno/historija-saradnje/${user.korisnickoIme}`,
          {
            headers: {
              token: token,
              "Content-Type": "application/json",
            },
          }
        );

        const najKlijenti = {};

        for (const klijent of response2.data) {
          klijent.cijena = parseInt(klijent.cijena);

          if (klijent.korisnickoIme in najKlijenti) {
            najKlijenti[klijent.korisnickoIme].cijena += klijent.cijena;
            najKlijenti[klijent.korisnickoIme].data.push(klijent);
          } else {
            najKlijenti[klijent.korisnickoIme] = {
              cijena: klijent.cijena,
              data: [klijent],
            };
          }
        }

        const najKlijentiArray = Object.keys(najKlijenti).map((key) => ({
          korisnickoIme: key,
          cijena: najKlijenti[key].cijena,
          data: najKlijenti[key].data,
        }));

        najKlijentiArray.sort((a, b) => b.cijena - a.cijena);

        setPonude(response.data);
        setHistorija(response2.data.slice().reverse());
        setNajprofKlijenti(najKlijentiArray);

        setError("");
      } catch (error) {
        setError("Error fetching data from the server.");
      }
    }

    fetchData();
    const checkInterval = setInterval(fetchData, 10000);
    return () => clearInterval(checkInterval);
  }, []);

  return (
    <>
      <Head title="Login fizickog lica" />
      <Container fluid="md">
        <HeaderComponent id="head-title-pravno-login" />
        {cookieData.logotip && (
          <img
            className="LogotipTitlePravnoLogin"
            src={`${baseUrl}/${cookieData.logotip}`}
            alt="LogotipHeader"
          />
        )}
        <Row>
          <Col md={6} className="pravna-lica-usluge pr-5">
            <h2 className="m-0">Novi zahtjevi za uslugama</h2>
            {error && <p className="error-message">{error}</p>}
            {ponude.length === 0 ? (
              <p className="error-message">Nemate novih zahtjeva.</p>
            ) : (
              <Card as={Container} className="card-container">
                <Card.Body as={Row}>
                  <Col md={16}>
                    {ponude.map((ponuda, index) => (
                      <NoviZahtjeviZaUslugamaCard
                        key={index}
                        datum={ponuda.datum}
                        ime={ponuda.imeFizickogLica}
                        kontakt={ponuda.kontaktFizickogLica}
                        poruka={ponuda.poruka}
                        id={index.toString()}
                      />
                    ))}
                  </Col>
                </Card.Body>
              </Card>
            )}
          </Col>
          <Col md={3} className="historija-saradnje-pravnog-lica">
            <h2>Historija saradnje</h2>
            <Row className="saradnja-ponude-container">
              {historija.length === 0 ? (
                <Col>
                  <p className="error-p">Nemate historije</p>
                </Col>
              ) : (
                <Col>
                  {historija.map((povijest, index) => {
                    return (
                      <SaradnjaPonude
                        naziv={povijest.korisnickoIme}
                        kontakt={povijest.telefon}
                        cijena={povijest.cijena}
                        datum={povijest.date}
                        key={index}
                      />
                    );
                  })}
                </Col>
              )}
            </Row>
          </Col>
          <Col md={3} className="pregled-ponuda-pravnog-lica">
            <h2>Najprofitabilniji klijenti</h2>
            <Row className="saradnja-ponude-container">
              {najprofKlijenti.length === 0 ? (
                <Col>
                  <p className="error-p">Nemate klijenata</p>
                </Col>
              ) : (
                <Col>
                  {najprofKlijenti.map((najProf, index) => {
                    console.log(najProf);
                    return (
                      <SaradnjaPonude
                        naziv={najProf.korisnickoIme}
                        kontakt={najProf.data[0].telefon}
                        cijena={najProf.cijena}
                        datum={najProf.data[0].date}
                        key={index}
                      />
                    );
                  })}
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default LoginPravnogLica;
